import {Component, OnInit, ViewChild} from '@angular/core';
import {PopoverController} from "@ionic/angular";
import {StudentMenuComponent} from "../student-menu/student-menu.component";
import {AuthService} from "../../../../services/mygreencountry/auth.service";
import {StudentService} from "../../../../services/mygreencountry/student.service";
import {Router} from "@angular/router";
import {LANGUAGES} from "../../../constants";
import {TranslocoService} from "@jsverse/transloco";
import {LocaleService} from "../../../../services/mygreencountry/locale.service";

@Component({
    selector: 'app-student-header',
    templateUrl: './student-header.component.html',
    styleUrls: ['./student-header.component.scss'],
})
export class StudentHeaderComponent implements OnInit {
    isPopMenuToggled: boolean = false;
    public isParent: boolean = false;


    constructor(
        public popoverController: PopoverController,
        private authService: AuthService,
        private studentService: StudentService,
        private router: Router,
    ) {

    }

    ngOnInit() {
        this.isParent = this.authService.isParent();
    }


    async showMenu(e: Event) {
        this.isPopMenuToggled = !this.isPopMenuToggled;

        const popover = await this.popoverController.create({
            component: StudentMenuComponent,
            showBackdrop: false,
            event: e,
            arrow: false,
            componentProps: {
                onClick: () => {
                    popover.dismiss();
                },
            },
            cssClass: 'student-menu-popover',
            mode: "ios",

        });

        await popover.present();

        popover.onDidDismiss().then(() => {
            this.isPopMenuToggled = !this.isPopMenuToggled;
        });
    }

    goToParentDashboard(){

        this.studentService.goToParentDashboard();
    }

    logout() {
        this.DismissClick()
        this.authService.logout();
        this.router.navigate(['/login']);
    }

    async DismissClick() {
        await this.popoverController.dismiss();
    }
}
